import type { Validation, ValidationType } from '../../../reducers';
export function getValidationByType(validationState: Array<Validation | undefined | null>, type: ValidationType) {
  return validationState.find(validation => {
    return validation ? validation.type === type : false;
  });
}